angular.module('impactx.basketLink').controller('SelectReferenceDialogCtrl', SelectReferenceDialogCtrl);

SelectReferenceDialogCtrl.$inject = ['$scope', 'dataGen', '$context', '$redirect', 'themeFactory', 'TranslationService', '$mdDialog', 'proId', 'bkiId', 'canDecideLater', 'ixaSearchSignals'];

function SelectReferenceDialogCtrl($scope, dataGen, $context, $redirect, themeFactory, TranslationService, $mdDialog, proId, bkiId, canDecideLater, ixaSearchSignals) {
    $scope.abortLabel = TranslationService.get("abort");
    $scope.saveLabel = TranslationService.get("save");
    $scope.theme = themeFactory.getTheme();
    $scope.selectedProducts = [];
    $scope.canDecideLater = canDecideLater;
    $scope.saveInProgress = false;
    var oldSelection = [];
    var self = this;
    self.errorListPats = [];
    self.errorList = [];

    dataGen.getData($scope, {proId: proId, bkiId: bkiId}, "/basket/selectreference/dialog").then(function () {
        for (var i = 0; i < $scope.data.references.length; i++) {
            var reference = $scope.data.references[i];
            if (reference.isSelected) {
                $scope.selectedProducts.push(reference);
                oldSelection.push(reference);
            }
        }
        self.checkForErrors();
    }, $mdDialog.cancel);

    this.detailsClicked = function () {
        if ($scope.selectedProducts.length > 0 && $scope.dialogData.$valid) {
            self.save();
        } else
        {
            self.cancel();
        }
    };

    this.save = function () {
        var selection = [];
        for (var i = 0; i < $scope.selectedProducts.length; i++) {
            var selectedProduct = $scope.selectedProducts[i];
            var amount = selectedProduct.amountAsNumber ? selectedProduct.amountAsNumber : 1;
            var indexInOldSelection = oldSelection.indexOf(selectedProduct);
            if (indexInOldSelection >= 0) {
                //product existing in old selection, use this amount.
                amount = oldSelection[indexInOldSelection].amountAsNumber;
            }
            var proId;
            var groupNumber;
            if (selectedProduct.variants) {
                proId = selectedProduct.selectedVariants[Object.keys(selectedProduct.selectedVariants)[0]].id;
                groupNumber = selectedProduct.selectedVariants[Object.keys(selectedProduct.selectedVariants)[0]].groupNumber;
            }
            else {
                proId = selectedProduct.id;
                groupNumber = selectedProduct.groupNumber;
            }
            selection.push({proId: proId, amount: amount, groupNumber: groupNumber});
            if ($scope.selectedProducts[i].id !== proId) {
                selection.push({proId: $scope.selectedProducts[i].id, amount: 0, groupNumber: $scope.selectedProducts[i].groupNumber})
            }
        }
        for (i = 0; i < oldSelection.length; i++) {
            var oldSelectedProduct = oldSelection[i];
            if ($scope.selectedProducts.indexOf(oldSelectedProduct) < 0) {
                //removed product -> add with amount = 0
                selection.push({proId: oldSelectedProduct.id, amount: 0, groupNumber: oldSelectedProduct.groupNumber})
            }
        }
        var dataObj = {
            mainProduct: $scope.data.mainProduct,
            references: selection,
            selectGroup: $scope.data.selectGroup
        };
        var tempScope = {};
        $scope.saveInProgress = true;
        dataGen.postAsForm(tempScope, dataObj, "/basket/selectreference/addtobasket").then(function () {

            const proId = $scope.data.mainProduct.groupNumber > 0? $scope.data.mainProduct.groupNumber : $scope.data.mainProduct.id;
            ixaSearchSignals.cart(proId)
            for(i = 0; i < selection.length; i++) {
                const refId = selection[i].groupNumber > 0? selection[i].groupNumber: selection[i].proId;
                ixaSearchSignals.cart(refId)
            }

            $scope.saveInProgress = false;
            $context.refreshBasket({}, dataGen, $context);
            $mdDialog.hide(tempScope.trns.success);
        }, function () {
            $scope.saveInProgress = false;
        });
    };

    this.cancel = function () {
        $mdDialog.cancel();
    };

    $scope.$watch(function () {
        return $scope.selectedProducts.length;
    }, function () {
        self.checkForErrors();
    });

    $scope.$watch(function () {
        return self.errorListPats.length;
    }, function () {
        self.checkForErrors();
    });

    self.checkForErrors = function () {
        if ($scope.data) {
            self.errorList.length = 0;
            self.errorList = self.errorList.concat(self.errorListPats);

            if ($scope.selectedProducts.length === 0) {
                self.errorList.push($scope.trns.chooseOne);
            }
        }
    };
}